export enum PermissionKey {
  READ_FILES = "read_files",
  UPLOAD_FILES = "upload_files",
  EDIT_FILES = "edit_files",
  DELETE_FILES = "delete_files",
  DOWNLOAD_FILES = "download_files",

  VIEW_METADATA = "view_metadata",
  MANAGE_APP_DATA = "manage_app_data",
  MANAGE_METADATA = "manage_metadata",
  VIEW_PHOTOS = "view_photos",
  VIEW_VIDEOS = "view_videos",
  VIEW_ALBUMS = "view_albums",
}

export const PermissionCatalog = {
  [PermissionKey.READ_FILES]: {
    key: PermissionKey.READ_FILES,
    label: "View files",
  },

  [PermissionKey.UPLOAD_FILES]: {
    key: PermissionKey.UPLOAD_FILES,
    label: "Upload files",
  },

  [PermissionKey.EDIT_FILES]: {
    key: PermissionKey.EDIT_FILES,
    label: "Edit files",
  },

  [PermissionKey.DELETE_FILES]: {
    key: PermissionKey.DELETE_FILES,
    label: "Delete files",
  },

  [PermissionKey.DOWNLOAD_FILES]: {
    key: PermissionKey.DOWNLOAD_FILES,
    label: "Download files",
  },

  [PermissionKey.VIEW_METADATA]: {
    key: PermissionKey.VIEW_METADATA,
    label: "View metadata",
  },
  [PermissionKey.MANAGE_APP_DATA]: {
    key: PermissionKey.MANAGE_APP_DATA,
    label: "Manage app data",
  },
  [PermissionKey.MANAGE_METADATA]: {
    key: PermissionKey.MANAGE_METADATA,
    label: "Manage metadata",
  },

  [PermissionKey.VIEW_PHOTOS]: {
    key: PermissionKey.VIEW_PHOTOS,
    label: "View photos",
  },
  [PermissionKey.VIEW_VIDEOS]: {
    key: PermissionKey.VIEW_VIDEOS,
    label: "View videos",
  },
  [PermissionKey.VIEW_ALBUMS]: {
    key: PermissionKey.VIEW_ALBUMS,
    label: "View albums",
  },
};
